import { useReactiveVar } from '@apollo/client';
import React, { SyntheticEvent } from 'react';

import useGetAdvertisersByOrgId from '../../../apis/graphql/advertisers/useGetAdvertisersByOrgId';
import useFetchAdAccountByUser from '../../../apis/graphql/user/useFetchAdAccountByUser/useFetchAdAccountByUser';
import { ReactComponent as CampaignManagerLogo } from '../../../assets/images/logo.svg';
import { selectedOrganizationIdVar, userAmsUserIdVar } from '../../../constants';
import useSetUserFromCurrentSession from '../../../hooks/useSetUserFromCurrentSession';
import { StyledLogoHeader } from './styled';

const Logo = (): JSX.Element => {
  const handleOnLogoClick = (e: SyntheticEvent): void => {
    e.preventDefault();
  };

  const selectedOrganizationId = useReactiveVar(selectedOrganizationIdVar) || '';
  const userAmsUserId = useReactiveVar(userAmsUserIdVar);
  const { userInfo } = useSetUserFromCurrentSession();

  const { adAccountsList } = useFetchAdAccountByUser(userInfo?.ams_user_id || userAmsUserId, selectedOrganizationId);
  const { advertisersOptions } = useGetAdvertisersByOrgId(selectedOrganizationId);

  return (
    <StyledLogoHeader onClick={handleOnLogoClick}>
      {adAccountsList?.length || !advertisersOptions.length ? <CampaignManagerLogo /> : 'Client Reporting Portal'}
    </StyledLogoHeader>
  );
};

export default Logo;
